import React from "react";
import { useStyleConfig, Box, TextProps, forwardRef } from "@chakra-ui/react";
import customTheme from "src/utils/theme";

const { textStyles } = customTheme;

const styleConfig = {
  sizes: {
    sm: {
      fontSize: "12px",
    },
    md: {
      fontSize: "14px",
    },
    lg: {
      fontSize: "16px",
    },
    xl: {
      fontSize: "20px",
    },
  },
  variants: { ...textStyles },
  defaultProps: {
    size: "lg",
    variant: "text",
  },
};

const BaseText = forwardRef((props, ref) => {
  const { size, variant, ...rest } = props;

  const styles = useStyleConfig("Text", { size, variant, styleConfig });

  return <Box sx={styles} {...rest} as="p" ref={ref} />;
});

export const Text = ({ children, ...rest }: TextProps) => <BaseText {...rest}>{children}</BaseText>;

export const CopyText = ({ children, ...rest }: TextProps) => (
  <BaseText size="lg" variant="copyText" {...rest}>
    {children}
  </BaseText>
);

export const TinyText = ({ children, ...rest }: TextProps) => (
  <BaseText size="sm" variant="tinyInfo" {...rest}>
    {children}
  </BaseText>
);

export const Tag = ({ children, color }: TextProps) => (
  <BaseText size="lg" variant="tag" background="transparent" textTransform="uppercase" color={color}>
    {children}
  </BaseText>
);

export const FooterText = ({ children, ...rest }: TextProps) => (
  <BaseText size="md" variant="footer" {...rest}>
    {children}
  </BaseText>
);

export const CardText = ({ children, ...rest }: TextProps) => (
  <BaseText size="xl" variant="cardText" {...rest}>
    {children}
  </BaseText>
);
